/**
 * @fileoverview Utilitário responsável por normalizar erros e exibir feedbacks em toast.
 */

import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";
import { isString } from 'lodash';
import { announcePlanLimit } from "../utils/planLimitEvent";

const toastError = err => {
    const AUTO_CLOSE_MS = 5000;
    const status = err.response?.status;
    const errorMsg = err.response?.data?.error;
    const toastBaseOptions = id => ({
        toastId: id,
    });

const showAndDismiss = (message, id) => {
    const toastId = toast.error(message, toastBaseOptions(id));
    // Fallback: garante remoção mesmo se alguma config impedir o autoClose
    setTimeout(() => toast.dismiss(toastId), AUTO_CLOSE_MS + 200);
};

// 413: nginx/multer devolvem HTML ou texto, não JSON — trata antes de cair no fallback genérico
if (status === 413) {
    showAndDismiss("Ops! O arquivo passou do limite de 100MB. Tenta compactar ou dividir :)", "payload-too-large");
    return;
}

// O limite do plano: o modal do layout explica e oferece os planos (o toast só se ninguém tratou).
if (typeof errorMsg === "string" && errorMsg.startsWith("ERR_PLAN_LIMIT_")) {
    const data = err.response?.data || {};
    if (announcePlanLimit({ code: errorMsg, used: data.used, limit: data.limit })) return;
}

if (errorMsg) {
    if (i18n.exists(`backendErrors.${errorMsg}`)) {
        console.error(`Error: ${i18n.t(`backendErrors.${errorMsg}`)}`);
        showAndDismiss(i18n.t(`backendErrors.${errorMsg}`), errorMsg);
        return;
    } else {
        showAndDismiss(errorMsg, errorMsg);
        return;
    }
}

if (isString(err)) {
    console.error(`Error: ${err}`);
    // Optionally log the error to an external service here
    /*
    toast.error(err, toastBaseOptions(err));
    */
    return;
} else {
    console.error("An error occurred!");
    // Optionally log the error to an external service here
    /*
    toast.error("An error occurred!", toastBaseOptions("generic-error"));
    */
    return;
}
};

export default toastError;
